import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import EmptyImage from '../../assets/empty.png';
import moment from 'moment';
import ToolTips from "../Shared/ToolTips";
import whiteStar from "../../assets/Star-white@3x.png";

class BrandResults extends Component {
    render() {
        const {campaign} = this.props;
        let uniqDate = campaign.date.map(d => moment(d).format('MMMM YYYY'))
        let dated = uniqDate.filter(function(item, pos, self) {
            return self.indexOf(item) == pos;
        })
        return (
                <tr>
                    <td className="creative-tr">
                        {typeof campaign.unit.thumbnail !== 'undefined' &&
                            <React.Fragment>
                                    <Link to={`/campaign/${campaign.id}`}>
                                        <div className="campaign-image">
                                            {campaign.unit.unit_type === 'mock' && campaign.unit.animated === "true" ?  <span className="mocked-icon mocked-icon-btm-left"> </span> :   <span className={`unit-type unit-type--${campaign.unit.unit_type} unit-type--bottom-left`}>{campaign.unit.unit_type}</span>}
                                            <img src={campaign.unit.thumbnail} alt={campaign.name}/>
                                        </div>
                                    </Link>
                                <div className="tool-wrapper">
                                    {campaign.unit.favorite_id !== null ?
                                        (<ToolTips content="Best in Class" data="bic">
                                        <span className="example-emoji" role="img" aria-label="cowboy emoji">
                                        <div style={ {background: "#e1ca6c", borderColor: "transparent"} } className="favorite-btn favorite-container"><img src={whiteStar} className="grey-star" alt=""/></div>
                                        </span>
                                        </ToolTips>) : ""}
                                </div>
                            </React.Fragment>
                        }
                        {typeof campaign.unit.thumbnail === 'undefined' &&
                            <Link to={`/campaign/${campaign.id}`}>
                                <div className="campaign-image">
                                    <span
                                        className={`unit-type unit-type--${campaign.unit.unit_type} unit-type--bottom-left`}>{campaign.unit.unit_type}</span>
                                    <img src={EmptyImage} alt={campaign.name}/>
                                </div>
                            </Link>
                        }
                    </td>
                    <td>
                        <Link to={`/campaign/${campaign.id}`} className="underline">
                            {campaign.name}
                        </Link>
                    </td>
                    <td>
                        {campaign.creative_types.map((ct, key) => (
                            <div className="brand-page-creative-format" key={key}>
                                <Link to={`/${ct.type}/${ct.id}`}>
                                    <span className={`unit-type unit-type--${ct.type}`}>{ct.type}</span>
                                   <div>{ct.creative_type}</div>
                                </Link>
                            </div>
                        ))}
                    </td>
                    <td>
                        {dated.map((date, key) => {
                            return(<div key={key}>{moment(date).format('MMMM YYYY')}</div>)
                        })}
                    </td>
                </tr>
        )
    }
}

export default BrandResults;